import { Autocomplete, TextField } from "@mui/material";
import { useTranslation } from "react-i18next";
import useDashboardStore from "@/state/dashboard";
import { shallow } from "zustand/shallow";
import { useNavigate, matchRoutes, useLocation } from "react-router-dom";
import { useEffect } from "react";
const { VITE_PRODUCTION_BASE } = import.meta.env;

const DashboardSelector = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const { selectedDashboard, selectDashboard, dashboards, resetAdditionalState } = useDashboardStore(
    (state) => ({
      selectedDashboard: state.selectedDashboard,
      selectDashboard: state.selectDashboard,
      dashboards: state.dashboards,
      resetAdditionalState: state.resetAdditionalState
    }),
    shallow
  );

  const options = dashboards.map((d, index) => ({
    name: d.name,
    value: index,
    label: t(d.name),
    callback: d.callback,
    path: d.path,
    disabled: d.disabled
  }));

  useEffect(() => {
    const path = location.pathname.replace(VITE_PRODUCTION_BASE, "").replace("/", "");
    if (path) {
      const foundValue = options.find((o) => o.path === path);
      selectDashboard(foundValue);
    } else {
      selectDashboard(options[0]);
    }
  }, []);

  useEffect(() => {
    if (selectedDashboard) {
      navigate(`${VITE_PRODUCTION_BASE}/${selectedDashboard.path}`);
    }
  }, [selectedDashboard ? selectedDashboard.value : null]);

  return (
    <Autocomplete
      disableClearable={true}
      value={selectedDashboard ? t(selectedDashboard.name) : ""}
      sx={{ width: { xs: "100%", md: 400 } }}
      options={options}
      renderInput={(params) => <TextField {...params} />}
      onChange={(event, newValue) => {
        if (newValue.callback) {
          newValue.callback();
          return;
        }
        selectDashboard(newValue);
      }}
      getOptionDisabled={(option) => option.disabled}
    />
  );
};
export default DashboardSelector;
